import { render } from "./HoSoQuickDrawer.vue?vue&type=template&id=25f86df6&ts=true"
import script from "./HoSoQuickDrawer.vue?vue&type=script&lang=ts"
export * from "./HoSoQuickDrawer.vue?vue&type=script&lang=ts"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__